import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth, dashboardPathForRole } from '@/App';

// Full-screen error state with a way OUT: retry + back home. Replaces the old
// nav-less dead-end pages (a transient network blip looked identical to a real 404).
export default function ErrorState({ message = '暫時無法載入', onRetry }) {
  const { user } = useAuth();
  const home = user ? dashboardPathForRole(user.role) : '/';
  const retry = onRetry || (() => window.location.reload());
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col items-center justify-center gap-3 px-6 text-center" data-testid="error-state">
      <p className="text-lg text-[#1A1A1A]">{message}</p>
      <p className="text-sm text-[#5C5C5C]">可能係網絡不穩，或伺服器啱啱由休眠中喚醒 — 再試一次多數得。</p>
      <div className="flex gap-3 mt-2">
        <Button onClick={retry} className="bg-[#C93B2B] text-white hover:bg-[#A82E20] rounded-sm" data-testid="error-retry">
          重試
        </Button>
        <Link to={home}>
          <Button variant="outline" className="rounded-sm" data-testid="error-home">返回主頁</Button>
        </Link>
      </div>
    </div>
  );
}
